module.exports = __webpack_public_path__ + "img/policy-yuri-review.0a3c9ef6.webp";